// Formula-safe CSV cell escaping (OWASP-style).
// Neutralizes spreadsheet formula injection (=, +, -, @, tab, CR) by
// prefixing a single quote, and always quotes cells that contain a
// delimiter, quote, or any newline (including bare CR).
export function csvCell(value) {
  let text = value === null || value === undefined ? "" : String(value);
  if (/^[=+\-@\t\r]/.test(text)) {
    text = `'${text}`;
  }
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function csvRow(values) {
  return values.map(csvCell).join(",");
}
